// extracted by mini-css-extract-plugin
export default {"container":"DoctorRefinements_container__sZD-W","aside":"DoctorRefinements_aside__gDuQQ","title":"DoctorRefinements_title__OAtJI"};